//TODO RH
import { lazy } from 'react'
import createAdminGuard, { createAdminMenuGuard } from '../guards/AdminGuard'
import AdjudicationAuditGuard from '../guards/AdjudicationAuditGuard'
import AuthGuard from '../guards/AuthGuard'
import AuctionLayout from '../layout/auction'
import LobbyLayout from '../layout/lobby'
import { ACTIONS, USER_ROLE } from '../utils/constants'

const routes = [
  {
    exact: true,
    path: '/',
    layoutTitle: 'Participar en Remate',
    component: lazy(() => import('../pages/home')),
    layout: LobbyLayout,
  },
  {
    exact: true,
    path: '/login',
    component: lazy(() => import('../pages/login')),
    layout: AuctionLayout,
  },
  {
    exact: true,
    path: '/logout',
    component: lazy(() => import('../pages/logout')),
    layout: AuctionLayout,
  },
  {
    exact: true,
    path: '/login/tcit',
    component: lazy(() => import('../pages/home')),
    layout: LobbyLayout,
  },
  {
    layoutTitle: 'Boton TCIT',
    exact: true,
    path: '/btntcit',
    component: lazy(() => import('../pages/btnTcit')),
    layout: LobbyLayout,
  },
  {
    layoutTitle: 'Verifica tu correo',
    exact: true,
    path: '/guestVerify',
    component: lazy(() => import('../pages/guestVerify')),
    layout: LobbyLayout,
  },
  {
    layoutTitle: 'Remates Activos',
    exact: true,
    path: '/auctionList',
    component: lazy(() => import('../pages/auctionList')),
    layout: LobbyLayout,
    guard: AuthGuard,
  },
  {
    layoutTitle: 'Remates Activos',
    exact: true,
    path: '/auctionList/:token',
    component: lazy(() => import('../pages/auctionList')),
    layout: LobbyLayout,
  },
  {
    exact: true,
    path: '/auction/:param1',
    component: lazy(() => import('../pages/auction')),
    layout: AuctionLayout,
    guard: AuthGuard,
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/integration',
    // path: '/integration/:param1',
    component: lazy(() => import('../pages/admin/pages/integration/index')),
    layout: AuctionLayout,
    guard: AuthGuard,
  },
  {
    exact: true,
    path: '/guarantee/:auctionId',
    layoutTitle: 'Participar En Remate',
    component: lazy(() => import('../pages/guarantee')),
    layout: LobbyLayout,
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/menu',
    layoutTitle: 'Panel De Administración',
    component: lazy(() => import('../pages/admin/pages/menu')),
    layout: LobbyLayout,
    guard: createAdminMenuGuard(),
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/dashboard',
    component: lazy(() => import('../pages/admin/pages/dashboard')),
    props: { variant: USER_ROLE.ADMIN },
    layout: AuctionLayout,
    guard: createAdminGuard(ACTIONS.ADMINISTRATOR_MODULE.VIEW_ADMINISTRATOR_MODULE),
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/auctioneer',
    component: lazy(() => import('../pages/admin/pages/auctioneer')),
    layout: AuctionLayout,
    guard: createAdminGuard(ACTIONS.AUCTIONEER_MODULE.VIEW_AUCTIONEER_MODULE),
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/roomControl',
    component: lazy(() => import('../pages/admin/pages/roomControl')),
    props: { variant: USER_ROLE.LOBBY },
    layout: AuctionLayout,
    guard: createAdminGuard(ACTIONS.ROOM_OFFER_MODULE.VIEW_ROOM_OFFER_MODULE),
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/room',
    component: lazy(() => import('../pages/admin/pages/room')),
    layout: AuctionLayout,
    guard: createAdminGuard(ACTIONS.ROOM_MODULE.VIEW_ROOM_MODULE),
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/userControl',
    component: lazy(() => import('../pages/admin/pages/userControl')),
    layout: AuctionLayout,
    guard: createAdminGuard(ACTIONS.USER_CONTROL_MODULE.VIEW_USER_CONTROL_MODULE),
  },
  {
    exact: true,
    path: '/expired',
    component: lazy(() => import('../pages/expired')),
    layout: AuctionLayout,
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/RobinHood',
    component: lazy(() => import('../pages/admin/pages/RobinHood')),
    layout: AuctionLayout,
    guard: createAdminGuard(ACTIONS.ROBIN_HOOD_MODULE.VIEW_ROBIN_HOOD_MODULE),
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/socialView',
    component: lazy(() => import('../pages/admin/pages/socialView')),
    layout: AuctionLayout,
    guard: AuthGuard,
  },
  {
    layoutTitle: 'rollback',
    exact: true,
    path: '/rollback',
    component: lazy(() => import('../pages/checkPoint/index')),
    layout: LobbyLayout,
    guard: AuthGuard,
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/userEntry',
    component: lazy(() => import('../pages/admin/pages/userEntry')),
    layout: AuctionLayout,
    guard: createAdminGuard(ACTIONS.USER_ENTRY_MODULE.USER_ENTRY_MODULE),
  },
  {
    exact: true,
    path: '/auction/:auctionId/admin/adjudicationAudit',
    component: lazy(() => import('../pages/adjudicationAudit')),
    layout: AuctionLayout,
    guard: AdjudicationAuditGuard,
  },
  {
    exact: true,
    path: '*',
    component: lazy(() => import('../layout/404/index')),
    layout: LobbyLayout,
  },
]

export default routes
